'use client'

import MobileHeaderSearchBar from '../MobileHeaderSearchBar'
import { useHeaderSearchType } from '../../hooks/useHeaderSearchType'

const ClientMobileSearchBar = (
  props: Pick<
    React.ComponentProps<typeof MobileHeaderSearchBar>,
    'catalogTree' | 'wrapperComponent'
  >,
) => <MobileHeaderSearchBar {...props} searchType={useHeaderSearchType()} />

export default ClientMobileSearchBar
